"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    Calibration: {
        Api: {
            FetchBaselineCalibrationBarcode: "/ScannerCalibration/BaselineCalibrationBarcode",
            FetchNextCalibrationBarcode: "/ScannerCalibration/NextCalibrationBarcode",
            FetchCalibrate: "/ScannerCalibration/Calibrate",
            FetchCalibrateForDom3KeyboardEventCodes: "/ScannerCalibration/CalibrateForDom3KeyboardEventCodes"
        }
    },
    Packs: {
        Api: {
            SinglePackRequest: "/api/Pack/GetPackResults",
            MultiPackReqeust: "/api/Pack/VerifyDecommissionMulti"
        }
    }
};
// TO DO: GetScannerValidationValue can be dropped once the switch has been made to use GetAppSettings
//# sourceMappingURL=endpoints.js.map